var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 72 72",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.79 1C20.13 1 20.41 1.28 20.41 1.62C20.41 15.5 20.41 56.5 20.41 70.38C20.41 70.72 20.13 71 19.79 71C16.03 71 5.38 71 1.62 71C1.28 71 1 70.72 1 70.38C1 56.5 1 15.5 1 1.62C1 1.28 1.28 1 1.62 1C5.38 1 16.03 1 19.79 1Z",
    id: "d3Bt5Z1kO"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipl5Y4u1aeI"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3Bt5Z1kO",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.22 2C43.5 2 43.72 2.22 43.72 2.5C43.72 8.91 43.72 27.66 43.72 34.07C43.72 34.35 43.5 34.57 43.22 34.57C40.2 34.57 31.65 34.57 28.63 34.57C28.35 34.57 28.13 34.35 28.13 34.07C28.13 27.66 28.13 8.91 28.13 2.5C28.13 2.22 28.35 2 28.63 2C31.65 2 40.2 2 43.22 2Z",
    id: "a1mLJjBOnc"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipa3Fe4T6MI8"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1mLJjBOnc",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.22 37.43C43.5 37.43 43.72 37.65 43.72 37.93C43.72 44.34 43.72 63.09 43.72 69.5C43.72 69.78 43.5 70 43.22 70C40.2 70 31.65 70 28.63 70C28.35 70 28.13 69.78 28.13 69.5C28.13 63.09 28.13 44.34 28.13 37.93C28.13 37.65 28.35 37.43 28.63 37.43C31.65 37.43 40.2 37.43 43.22 37.43Z",
    id: "c1L0FBpgdX"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipa1ljyiaAdd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1L0FBpgdX",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.33 4.36C70.25 4.36 71 5.1 71 6.02C71 6.7 71 7.06 71 7.73C71 8.65 70.25 9.39 69.33 9.39C65.27 9.39 54.72 9.39 50.66 9.39C49.74 9.39 49 8.65 49 7.73C49 7.06 49 6.7 49 6.02C49 5.1 49.74 4.36 50.66 4.36C54.72 4.36 65.27 4.36 69.33 4.36Z",
    id: "a1MLjFel6s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34 14.61C70.25 14.61 71 15.35 71 16.27C71 17.01 71 17.56 71 18.3C71 19.22 70.25 19.96 69.34 19.96C65.27 19.96 54.72 19.96 50.66 19.96C49.74 19.96 49 19.22 49 18.3C49 17.56 49 17.01 49 16.27C49 15.35 49.74 14.61 50.66 14.61C54.72 14.61 65.27 14.61 69.34 14.61Z",
    id: "c1PBnLCbUp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34 25.2C70.25 25.2 71 25.95 71 26.86C71 27.6 71 28.16 71 28.9C71 29.81 70.25 30.56 69.34 30.56C65.27 30.56 54.72 30.56 50.66 30.56C49.74 30.56 49 29.81 49 28.9C49 28.16 49 27.6 49 26.86C49 25.95 49.74 25.2 50.66 25.2C54.72 25.2 65.27 25.2 69.34 25.2Z",
    id: "a1exqeNuJg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34 41.32C70.25 41.32 71 42.06 71 42.98C71 43.72 71 44.27 71 45.01C71 45.93 70.25 46.67 69.34 46.67C65.27 46.67 54.72 46.67 50.66 46.67C49.74 46.67 49 45.93 49 45.01C49 44.27 49 43.72 49 42.98C49 42.06 49.74 41.32 50.66 41.32C54.72 41.32 65.27 41.32 69.34 41.32Z",
    id: "c4F6IsxlWZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34 52.04C70.25 52.04 71 52.78 71 53.7C71 54.44 71 54.99 71 55.73C71 56.65 70.25 57.39 69.34 57.39C65.27 57.39 54.72 57.39 50.66 57.39C49.74 57.39 49 56.65 49 55.73C49 54.99 49 54.44 49 53.7C49 52.78 49.74 52.04 50.66 52.04C54.72 52.04 65.27 52.04 69.34 52.04Z",
    id: "c3q7lp1Rf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34 62.64C70.25 62.64 71 63.38 71 64.3C71 65.04 71 65.6 71 66.33C71 67.25 70.25 67.99 69.34 67.99C65.27 67.99 54.72 67.99 50.66 67.99C49.74 67.99 49 67.25 49 66.33C49 65.6 49 65.04 49 64.3C49 63.38 49.74 62.64 50.66 62.64C54.72 62.64 65.27 62.64 69.34 62.64Z",
    id: "a5OcUPLbJg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipl5Y4u1aeI)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3Bt5Z1kO",
    opacity: 1,
    fillOpacity: 0,
    stroke: "currentColor",
    strokeWidth: 12,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipa3Fe4T6MI8)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1mLJjBOnc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "currentColor",
    strokeWidth: 10,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipa1ljyiaAdd)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1L0FBpgdX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "currentColor",
    strokeWidth: 10,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1MLjFel6s",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1PBnLCbUp",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1exqeNuJg",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4F6IsxlWZ",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3q7lp1Rf4",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5OcUPLbJg",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpic);
export default __webpack_public_path__ + "static/media/epic.bb400630.svg";
export { ForwardRef as ReactComponent };